import React from 'react'
import Head from 'next/head'
import LegalPage from 'pages/website/LandingPage/EntrepreneurSeminar/LegalPage'
import { privacyPolicy } from 'pages/website/LandingPage/EntrepreneurSeminar/legalContent'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import CommonHead from '../_head'

// Old renderer, kept for revert:
// import PrivacyPolicyPage from '../../src/pages/website/PrivacyPolicy/PrivacyPolicy'

const PrivacyPolicy = () => {
  const onIntakeSubmit = useJumpstartIntake('jumpstart')

  return (
    <>
      <Head>
        <title>Privacy Policy | Entrepreneur Seminar</title>
        <CommonHead description="How Entrepreneur Seminar collects, stores and uses your information." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
        />
      </Head>
      <LegalPage document={privacyPolicy} onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default PrivacyPolicy
